jQuery( function( $ ) {
	const formFilter = $( '.location-filter' );
  // var url = null;
  // var urlParams = null;
  // if(formFilter.length > 0) { //locations page only
  //   //url params
  //   url = new URL(window.location.href);
  //   urlParams = url.searchParams;
  // }

  // $(window).on("load", function() {
  //   if(formFilter.length > 0) {
  //     urlParams.set('region', 'all');
  //     urlParams.set('countries', 'all');
  //     //update the address bar
  //     url.search = urlParams.toString();
  //     window.history.pushState({}, '', url);
  //   }
  // });

  formFilter.on('submit change', function(e) {
    e.preventDefault();
    var target_element = $(e.target);
    $.ajax( {
			url: location_filter_obj.ajaxurl,
      method: 'POST',
      dataType: 'json',
      data: {
        action:'locationfilter',
        trigger: target_element.attr("name"),
        param: formFilter.serialize()
      },
      beforeSend: function( xhr ) {
        $('.filter-wrapper, .section--all-locations').addClass('loading');
      },
      success: function(data) {
        //setting url
        // urlParams.set('region', data['region']);
        // urlParams.set('countries', data['countries']);
        // if(urlParams.get('region') == 'all') {
        //   urlParams.set('countries', 'all');
        //   $('input[name="country"]').prop('checked', false).removeAttr('checked');
        //   $('input[name="country"][value="all"]').prop("checked",true).attr('checked', 'checked');
        // }
        // url.search = urlParams.toString();
        // window.history.pushState({}, '', url); 
        // This outputs the result of the ajax request
        var country_list = '', location_list = '';
        var countries = data['countries'];
        var locations = data['locations'];
        var region = data['region'];

        $('input[name=region]').each(function(index, element) {
          if(region === $(this).val()) $(this).prop('checked', true);
        });

        //setting the heading
        $('#location-title').html(data['heading']);

        if(countries) {

          Object.values(countries).forEach(country => {

            var checked = (country['current_country'] && data['in_region'] != 'all') ? 'checked' : '';

            country_list += `<li class="form-check form-check-inline">`;
            country_list += `<input ${checked} class="form-check-input" type="radio" value="${country['id']}" id="country_${country['id']}" name="country">`;
            country_list += `<label class="form-check-label ms-1" for="country_${country['id']}">${country['name']}</label>`;
            country_list += `</li>`;
          });
        }

        if(country_list.length == 0  || country_list == '' || country_list == undefined) {
          $('.country-list').html('No countries found.');  
        } 
        else $('.country-list').html(country_list);

        //locations
        if(locations) {
          let location_icao = '';
          Object.values(locations).forEach(location => {
            location_icao = splitIcaoCharacters(location['icao']);
            location_list += `<div class="featured-location card">`
            //header
            location_list += `<a href="${location['url']}" class="card-header" style="background-image: url(${location['image']})">
              <img class="card-img-top img-fluid d-none" src="${location['image']}"/>
              <div class="header__info">
                <div class="header__info__wrapper">
                  <div class="info__icao">${location_icao}</div>
                  <div class="info__cert">
                </div>
              </div>
              </div>
            </a>`;
            
            //body
            location_list += `<div class="card-body p-3 pt-md-4 pb-md-2">
              <div class="location-information d-flex flex-column h-100">
                <h4 class="location-name"><a href="${location['url']}">${location['airport']}</a></h4>
                <div class="location-country d-block mt-auto"><i class="fa-sharp fa-light fa-map-location me-2"></i>${location['city']}</div>
              </div>
            </div>`;

            //footer
            location_list += `<div class="location-region card-footer">
              <div class="card-footer__wrapper text-center">
                <a class="card-cta" title="See coverage in ${location['country']['name']}" href="${location['country']['url']}">See coverage in ${location['country']['name']} <i class="fa-sharp fa-regular fa-arrow-right"></i></a>
              </div>
            </div>`

            //end of card
            location_list += `</div>`
          });
          $('#locations-wrapper').html(location_list);
        }

        $('.filter-wrapper, .section--all-locations').removeClass('loading');
      },
      error: function(errorThrown){
        console.log(errorThrown);
      }

		});
  });
} );